import { createContext } from "react";

import type { PersonalTrainerQuery } from "~/modules/admin/types";

type ContextData = {
	handleChangeSearch(search: string): void;
	handleRemoveFromList(personalTrainerId: string): void;
	filter: PersonalTrainerQuery;
};

export const context = createContext<ContextData>({} as ContextData);
